import React, { useEffect } from 'react'
import ScriptNext, { type ScriptProps } from 'next/script'

type IScriptProps = ScriptProps & {
  children?: React.ReactNode
}

export default function Script(props: IScriptProps) {
  const { src, children, id, ...restProps } = props

  useEffect(() => {
    if (!process.env.VITE_S4L_STUDIO) return undefined

    const script = document.createElement('script')
    if (src) script.src = src
    if (id) script.id = id
    if (children) script.textContent = String(children)

    // Agregar atributos HTML adicionales
    Object.keys(restProps).forEach(key => {
      const value = restProps[key as keyof typeof restProps]
      if (value !== undefined && value !== null) {
        script.setAttribute(key, String(value))
      }
    })

    document.head.appendChild(script)

    return () => {
      document.head.removeChild(script)
    }
  }, [src, children, id, restProps])

  if (process.env.VITE_S4L_STUDIO) {
    return null
  }

  return <ScriptNext {...props} />
}
